import React from "react";
import "./footer.css";
import instagram from "../media/instagram.png";

function Footer() {
  return (
    <div id="footer">
      <div id="footer_contents">
        <div id="links">
          <h4> Connect with Us </h4>
        </div>
        <div id="contact">
          <div id="info">
            <div id="main">
              <div>
                <p> Email </p>
              </div>
            </div>
            <div>
              <p id="email"> periodfriend2021@gmail.com </p>
            </div>
          </div>
          <div id="signature">
            {/* <p>
              Made with
              <img
                id="heart"
                src={require("../media/heart.png")}
                alt="heart"
                width="15px;"
              />
              by PERIODFRIEND
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
